import { Link } from "react-router-dom";
import { Linkedin, Github, Mail, ArrowUpRight } from "lucide-react";
import { LINKS } from "../lib/content";

const COLS = [
  { title: "Site", links: [["About", "/about"], ["Projects", "/projects"], ["Services", "/services"], ["Blog", "/blog"]] },
  { title: "More", links: [["Resources", "/resources"], ["Speaking", "/speaking"], ["Contact", "/contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms", "/terms"]] },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
      <div className="col-span-2">
        <p className="font-display text-xl font-semibold tracking-tight">Yash Bhatt<span className="text-secondary">.</span></p>
        <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-xs">
          AI Strategy & Enterprise Solutions Consultant. Helping organizations transform with AI, data & enterprise technology.
        </p>
        <div className="flex gap-3 mt-6">
          <a data-testid="footer-linkedin" href={LINKS.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-9 w-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-secondary hover:border-secondary/50 transition-colors duration-200"><Linkedin size={15} /></a>
          <a data-testid="footer-github" href={LINKS.github} target="_blank" rel="noreferrer" aria-label="GitHub" className="h-9 w-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-secondary hover:border-secondary/50 transition-colors duration-200"><Github size={15} /></a>
          <a data-testid="footer-email" href={`mailto:${LINKS.email}`} aria-label="Email" className="h-9 w-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-secondary hover:border-secondary/50 transition-colors duration-200"><Mail size={15} /></a>
        </div>
      </div>
      {COLS.map((col) => (
        <div key={col.title}>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{col.title}</p>
          <ul className="space-y-3">
            {col.links.map(([label, to]) => (
              <li key={to}><Link to={to} className="text-sm text-foreground/80 hover:text-secondary transition-colors duration-200">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Yash Bhatt. All rights reserved.</p>
        <a href={LINKS.calendly} target="_blank" rel="noreferrer" className="text-xs text-secondary inline-flex items-center gap-1 hover:underline">
          Start a conversation <ArrowUpRight size={12} />
        </a>
      </div>
    </div>
  </footer>
);
